import React, { useEffect, useState } from 'react';
import Button from '../ui/Button';
import {
  acceptAllPrivacyConsent,
  applyGpcIfPresent,
  hasPrivacyConsentChoice,
  rejectOptionalPrivacyConsent,
} from '../../utils/privacyConsent';
import { CookiePreferencesModal } from './CookiePreferencesModal';
import apiService from '../../services/ApiService';

export const CookieConsentBanner: React.FC = () => {
  const [visible, setVisible] = useState(false);
  const [manageOpen, setManageOpen] = useState(false);

  useEffect(() => {
    const gpcRecord = applyGpcIfPresent();
    if (gpcRecord?.gpc) {
      void apiService.savePrivacyConsentRemote({
        consent_version: gpcRecord.version,
        analytics: gpcRecord.categories.analytics,
        advertising: false,
        personalization: gpcRecord.categories.personalization,
        gpc_signal: true,
        source: 'gpc',
        subject_key: localStorage.getItem('bilt_view_session') || undefined,
      });
    }
    setVisible(!hasPrivacyConsentChoice());
  }, []);

  const persistRemote = (categories: {
    analytics: boolean;
    advertising: boolean;
    personalization: boolean;
  }) => {
    void apiService.savePrivacyConsentRemote({
      consent_version: '2026-08-14',
      ...categories,
      gpc_signal: Boolean((navigator as any).globalPrivacyControl),
      source: 'banner',
      subject_key: localStorage.getItem('bilt_view_session') || undefined,
    });
  };

  if (!visible) {
    return (
      <CookiePreferencesModal
        isOpen={manageOpen}
        onClose={() => setManageOpen(false)}
        onSaved={() => setManageOpen(false)}
      />
    );
  }

  return (
    <>
      <div
        className="fixed inset-x-0 bottom-0 z-[100] p-4 sm:p-6"
        role="dialog"
        aria-modal="false"
        aria-label="Cookie and privacy choices"
      >
        <div className="mx-auto max-w-3xl rounded-xl border border-white/10 bg-[#0c0c0c]/95 backdrop-blur-md shadow-2xl shadow-black/50 p-4 sm:p-5">
          <p className="text-sm text-gray-200 leading-relaxed">
            Bilt:Spec uses necessary storage to keep you signed in. Optional analytics and advertising storage stay off unless you allow them.
            Read the{' '}
            <a href="/cookies" className="text-orange-300 hover:text-orange-200 underline-offset-2 hover:underline">
              Cookie Policy
            </a>
            .
          </p>
          <div className="mt-4 flex flex-col sm:flex-row gap-2 sm:items-center">
            <Button
              type="button"
              variant="primary"
              className="min-h-[44px]"
              onClick={() => {
                const c = acceptAllPrivacyConsent();
                persistRemote(c.categories);
                setVisible(false);
              }}
            >
              Accept all
            </Button>
            <Button
              type="button"
              variant="secondary"
              className="min-h-[44px]"
              onClick={() => {
                const c = rejectOptionalPrivacyConsent();
                persistRemote(c.categories);
                setVisible(false);
              }}
            >
              Reject optional
            </Button>
            <Button
              type="button"
              variant="ghost"
              className="min-h-[44px]"
              onClick={() => setManageOpen(true)}
            >
              Manage preferences
            </Button>
          </div>
        </div>
      </div>
      <CookiePreferencesModal
        isOpen={manageOpen}
        onClose={() => setManageOpen(false)}
        onSaved={() => {
          setManageOpen(false);
          setVisible(false);
        }}
      />
    </>
  );
};

export default CookieConsentBanner;
